import Base2Repository from "./base2.repository";
import { GenericPersistence } from "core/data/persistence";
import { GenericService } from "core/data/service";

class OrderIntegration extends Base2Repository {
  getPersistenceProvider() {
    return new GenericPersistence(this.getEntityIdentifier());
  }

  getServiceProvider() {
    return new GenericService({
      fetch: "/v1/order_integrations",
      create: "/v1/order_integrations",
      update: "/v1/order_integrations"
    });
  }

  async getOrderIntegration(company_uuid) {
    return await this.get(
      `/v1/companies/${company_uuid}/order_integrations`,
      {
        page: 1,
        count: 25
      }
    );
  }

  async postOrderIntegration(params) {
    return await this.create({
      company_uuid: params.company_uuid,
      account_uuid: params.account_uuid,
      name: params.name,
      username: params.login,
      password: params.password,
      origin: params.origin,
      payment_uuid: params.paymentType === "" ? null : params.paymentType,
      enabled: true,
      auto_accept: params.auto_accept
    });
  }

  async updateOrderIntegration(params, uuid) {
    return await this.update(uuid, {
      company_uuid: params.company_uuid,
      account_uuid: params.account_uuid,
      name: params.name,
      username: params.login,
      password: params.password,
      origin: params.origin,
      payment_uuid: params.paymentType === "" ? null : params.paymentType,
      enabled: params.enabled,
      auto_accept: params.auto_accept
    });
  }
}

export default new OrderIntegration();



// WEBPACK FOOTER //
// ./src/core/repository/order-integration.repository.js